<span [ngClass]="disabled == true ? 'disabled' : 'required'">*</span>
